// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //serverUrl: 'https://apidet.kairosmining.com',
  //serverUrlSocket: 'http://localhost:5000',
  //serverUrl: 'http://200.75.4.220:5010',
  //serverUrl: 'https://200.75.4.220:5002',

  serverUrl: 'https://apidchcodelco.kairosmining.com',
  //serverUrl: 'http://localhost:5001',

    //serverUrl: 'https://apidchcodelco.kairosmining.com', //aquí
  //serverUrl: 'https://apidchcodelco.kairosmining.com',
  //serverUrl: 'https://apigidc.kairosmining.com',
  defaultLanguage: 'es-CL',
  supportedLanguages: ['es-CL'],
  firebase: {
    apiKey: "AIzaSyD3LuvAYIcheBHI0yqi3yJ-n0n5cVPzgFM",
    authDomain: "detweb-fae4d.firebaseapp.com",
    databaseURL: "https://detweb-fae4d.firebaseio.com",
    projectId: "detweb-fae4d",
    storageBucket: "detweb-fae4d.appspot.com",
    messagingSenderId: "900419796914",
    appId: "1:900419796914:web:ddc67beb0298b2e91daeab",
    measurementId: "G-JFF58BNLEE"
  }
};
